<template>
  <DoRight
    ref="right"
    :limitTime="limitTime"
    :reportId="reportId"
    :scantron="scantron"
    :hasSection="hasSection"
    :answer="answer"
    :current="current"
    @getTopic="onGetTopic"
    @submitTopic="onSubmitTopic"
    @submit="onSubmit"
  ></DoRight>
</template>
<script>
import DoRight from "@/components/ques/DoRight.vue";
export default {
  name: "ExamDoRight",
  components: {
    DoRight,
  },
  props: {
    limitTime: {
      type: Number,
      default: 0,
    },
    reportId: {},
    scantron: {
      type: Object,
      default: () => {
        return {};
      },
    },
    hasSection: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      current: {},
    };
  },
  computed: {
    total() {
      return this.scantronQuestions.length;
    },
    answerCount() {
      return this.scantronQuestions.filter(q => q.status == 1 || q.status == 2)
        .length;
    },
    scantronQuestions() {
      if (!this.scantron.list) {
        return [];
      }
      if (this.hasSection) {
        let list = [];
        this.scantron.list.forEach(t => {
          t.child.forEach(ques => {
            list.push(ques);
          });
        });
        return list;
      } else {
        return this.scantron.list;
      }
    },
  },
  methods: {
    init(index, seconds) {
      this.$refs.right.init(index, seconds);
    },
    async onGetTopic({ reportId, index }) {
      let data = await this.$http.get(
        "/api/app/practice/question/" + reportId,
        { page: index },
      );
      let ques = data.list[0];
      if (ques.ques_type != 5 && typeof ques.ques_option === "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
      ques.index = index;
      this.current = ques;
      this.$emit("topicChange", ques);
    },
    async onSubmitTopic({ report_id, question_id, user_answer, answer_time }) {
      await this.$http.post("/api/app/practice/storeQuestion", {
        report_id: report_id,
        question_id: question_id,
        user_answer: user_answer,
        answer_time: answer_time,
      });
    },
    async onSubmit({ id, answer_time }) {
      await this.$http.post("/api/app/practice/storeReport", {
        id: id,
        answer_time: answer_time,
      });

      this.$emit("submit");
    },
    async navNext() {
      this.$refs.right.navNext();
    },
  },
};
</script>
